import React from 'react'
import styles from './styles.module.css'

interface Props {
    title: string,
    body: string,
    index?: string | number,
    isDone: boolean
}

const TicketStatusItem: React.FC<Props> = ({
    title,
    body,
    index=1,
    isDone
}) => {
  return (
    <div className={`${styles.statusItem} ${isDone ? styles.done : styles.notDone}`}>

      <div className={styles.pointerContainer}>
        <div>
          <div className={styles.pointerCircle}></div>
        </div>
      </div>
      
      <div className={styles.countBox}>
        <div>
        <p>{index}</p>
        </div>
      </div>
      <div className={styles.detailsBox}>
        <h4>{title}</h4>
        <p>{body}</p>
      </div>
    </div>
  )
}

export default TicketStatusItem